/* eslint-disable */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { BsCartPlus } from "react-icons/bs";
import { MdDeleteOutline } from "react-icons/md";
import { userDataActionCreators } from "../../../../../service/action-creators";
import AddToCartModal from "./AddToCartModal";
import "./ProductCard.css";

function ProductCard({ product }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [cartModalProduct, setCartModalProduct] = useState(null);

  const { RemoveFavoriteProducts, AddProductToCart } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );

  const carts = useSelector((state) => state?.user?.cart);
  const prod = product?.product_id;

  return (
    <>
      <div className="favCard">
        {/* Image */}
        <div
          className="favCard-img"
          onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
        >
          <img src={prod?.images?.[0]?.url} alt={prod?.product_name} />
          {prod?.percent > 0 && (
            <span className="favCard-badge">{prod?.percent}% off</span>
          )}
        </div>

        {/* Info */}
        <div
          className="favCard-info"
          onClick={() => history.push({ pathname: "/product-detailed", state: { product: prod } })}
        >
          <p className="favCard-name">
            {prod?.product_name?.length > 55
              ? prod?.product_name.slice(0, 55) + "..."
              : prod?.product_name}
          </p>
          <div className="favCard-prices">
            <span className="favCard-newPrice">&#8373;{prod?.new_price}</span>
            {prod?.old_price && (
              <span className="favCard-oldPrice">&#8373;{prod?.old_price}</span>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="favCard-actions">
          <button
            className="favCard-addBtn"
            disabled={Number(prod?.quantity ?? 0) <= 0}
            style={
              Number(prod?.quantity ?? 0) <= 0
                ? { opacity: 0.5, cursor: "not-allowed" }
                : undefined
            }
            onClick={(e) => {
              e.stopPropagation();
              if (Number(prod?.quantity ?? 0) <= 0) return;
              setCartModalProduct(prod);
            }}
          >
            <BsCartPlus size={14} />
            {Number(prod?.quantity ?? 0) <= 0 ? "Out of Stock" : "Add to Cart"}
          </button>
          <button
            className="favCard-removeBtn"
            onClick={(e) => { e.stopPropagation(); RemoveFavoriteProducts(product?._id); }}
            title="Remove from favourites"
          >
            <MdDeleteOutline size={17} />
          </button>
        </div>
      </div>

      {cartModalProduct && (
        <AddToCartModal
          product={cartModalProduct}
          carts={carts}
          onAdd={(payload) => dispatch(AddProductToCart(payload))}
          onClose={() => setCartModalProduct(null)}
        />
      )}
    </>
  );
}

export default ProductCard;
